import { useCallback } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { useTranslation } from 'react-i18next';
import './style.scoped.css';
import Button, { ButtonTypes } from 'src/components/Button';
import chrevronRight from 'src/assets/chevron_right_blue.svg';
import { Link } from 'react-router-dom';
import { sendOpenNewWebview } from 'src/utils';
import { HomeNewsPromotionType } from 'src/constants';

export interface HomeNewsAndPromotionProps {
  title: string;
  data?: any[];
  viewAllPath?: string;
}
const HomeNewsAndPromotion = (props: HomeNewsAndPromotionProps) => {
  const { data, title, viewAllPath } = props;
  const { t } = useTranslation();

  const _handlePressItem = useCallback((item) => {
    sendOpenNewWebview(item);
  }, []);

  const _renderItem = (item, index) => {
    return (
      <div
        className="itemSlider"
        key={item.id}
        onClick={() => _handlePressItem(item)}
      >
        <img src={item.photo} className="itemSliderImage" />
        <div className="smallTitle name">{item.name}</div>
        <div className={'flex flex-row'}>
          <div
            className={
              item.type == HomeNewsPromotionType.PROMOTION
                ? 'badge badgeAttention'
                : 'badge badgePrimary'
            }
          >
            {t(
              item.type == HomeNewsPromotionType.PROMOTION
                ? 'promotion'
                : 'news'
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="titleContainer">
        <div className="blockTitle3 flex flex-1 text-onSurface">{title}</div>
      </div>
      {data && data.length > 0 ? (
        <div className="scrollContainer flex flex-row">
          {data.map(_renderItem)}
        </div>
      ) : (
        <div className="h-11"></div>
      )}
      <div className="mx-4">
        <Link to={viewAllPath}>
          <Button
            text={t('view_more')}
            buttonType={ButtonTypes.primaryBorderless2}
            extraClassName="w-full"
            rightIcon={<img src={chrevronRight} className="w-6 h-6 ml-2" />}
          />
        </Link>
      </div>
    </div>
  );
};

export default HomeNewsAndPromotion;
